module.exports = __webpack_public_path__ + "assets/img/teacher (32).548be19f.png";